import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const stateService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    softDelete,
    destroy,
};

const MODULE = {
    STATE: 'states',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
            country_uuid: filter?.countryUUID,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.STATE}`, request);
}

export function store (data) {
    const request = {
        name: data.name,
        country_uuid: data.countryUUID,
    };

    return apiHelper(API_URL).post(`/${MODULE.STATE}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.STATE}/${uuid}`);
}

export function update (data) {
    const request = {
        name: data.name,
        country_uuid: data.countryUUID,
    };

    return apiHelper(API_URL).put(`/${MODULE.STATE}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.STATE}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.STATE}/delete/${data.uuid}`);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.STATE}/${data.uuid}`);
}
